import {
  GET_CRM_ENQUIRY,
  GET_CRM_ENQUIRY_SOURCE,
  GET_CUSTOMER_BUDGET,
  GET_CRM_DIMENSION,
  GET_CUSTOMER_CONSTRUCTIONS_PLANNING,
  GET_CUSTOMER_PURCHASE_REASON,
  GET_CRM_SITE_SOLD,
  GET_CRM_CUSTOMER_ENQUIRY,
  GET_CRM_ENQUIRY_PROFILE,
  GET_CRM_ENQUIRY_PROFILE_EXPORT,
  GET_SITE_VISIT_FEEDBACK_QUESTION,
  GET_SITE_VISIT_FEEDBACK,
  GET_SITE_VISIT_FEEDBACK_EXPORT,
  GET_SITE_VISIT_FEEDBACK_DETAIL,
  GET_CRM_BOOKING_ENQUIRY_PROFILE,
  GET_CRM_MEETING,
  GET_CRM_MEETING_CATEGORY,
  GET_CRM_MEETING_ATTENDEE,
  GET_CRM_MEETING_DETAIL,
  GET_CRM_MEETING_EXPORT,
  GET_CRM_MEETING_SOURCE,
  GET_CRM_MEETING_CHANNEL_PARTNER_INFO,
  GET_CRM_MEETING_CHANNEL_CLIENT_INFO,
  GET_CRM_MEETING_PREFERRED_LOCATION,
  GET_CRM_MEETING_PREFERRED_LOCATION_EXPORT,
  GET_CRM_MEETING_STM_INFO,
  GET_CRM_SOURCE_GROUP,
  GET_CRM_SOURCE_GROUP_EXPORT,
  GET_CRM_SOURCE_CATEGORY,
  GET_CRM_SOURCE,
  GET_CRM_ENQUIRY_STATUS,
  GET_CRM_ENQUIRY_CALL_STATUS,
  GET_CRM_ENQUIRY_CATEGORY,
  GET_DIMENSION_MASTER,
  GET_RELEASE_STATUS,
  GET_CRM_SITE_PREMIUM_TYPE,
  GET_CRM_SITE_STATUS,
  GET_SITE_INVESTOR,
  GET_BLOCK_REASON,
  GET_ENQUIRY_FOLLOW_STATUS,
  GET_CRM_CHANNEL_PARTNER,
  GET_CRM_CLIENT,
  GET_CRM_STM,
  GET_CRM_MEETING_FILTER_PROJECT,
  GET_CRM_MEETING_FILTER_HOSTED_BY,
  GET_FELLOW_UP,
  GET_FELLOW_UP_EXPORT,
  GET_CRM_FOLLOW_UP_FILTER_ASSIGNED_TO,
  GET_CRM_ENQUIRY_FOLLOW_UP_REASON,
  GET_CRM_SITE_FACE,
  GET_CRM_CANCELLATION_REASON,
  GET_PROMOTIONAL_ACTIVITY,
  GET_PROMOTIONAL_ACTIVITY_FILTER_PROJECT,
  CHECK_EXISTING_ENQUIRY,
  GET_ACTIVITY_FOR_PROMOTIONAL_LEAD,
  GET_PROMOTIONAL_LEAD,
  GET_PROMOTIONAL_LEAD_FILTER_PROJECT,
  GET_PROMOTIONAL_LEAD_FILTER_SOURCE,
  GET_PROMOTIONAL_LEAD_FILTER_ACTIVITY,
  GET_SOURCE_FOR_PROMOTIONAL_LEAD,
  GET_USER_FOR_PROMOTIONAL_LEAD,
  GET_LEAD_FOR_SITE_VISIT,
  GET_LEAD_DETAIL_FOR_SITE_VISIT,
  GET_SITE_VISIT,
  GET_EOI_PRICE,
  GET_EOI_PRICE_FILTER_PROJECT,
  GET_EXPRESSION_OF_INTEREST,
  GET_EXPRESSION_OF_INTEREST_EXPORT,
  GET_EOI_PRICE_FILTER_DIMENSION,
  GET_CUSTOMER_INFO,
  GET_EXPRESSION_OF_INTEREST_DETAIL,
  GET_EXPRESSION_OF_INTEREST_FILTER_PROJECT,
  GET_EOI_PRICE_DETAIL,
  GET_SITE_FACING,
  GET_EOI_PAYMENT_DETAIL,
  GET_COMPANY_FOR_CRM_PROJECT,
  GET_CUSTOMER_TICKET,
  GET_USER_TICKET_FILTER,
  GET_CUSTOMER_TICKET_EXPORT,
  GET_TICKET_FOLLOW_UP,
  GET_CUSTOMER_TICKET_DETAIL,
  GET_PROJECT_TICKET_FILTER,
  GET_CUSTOMER_TICKET_STATUS,
  //CustomerTicketCategory
  GET_CUSTOMER_TICKET_CATEGORY,
  GET_CUSTOMER_TICKET_CATEGORY_EXPORT,
  GET_CUSTOMER_TICKET_FILTER_STATUS,
  GET_CUSTOMER_TICKET_FOR_ASSINGNED_USER,
  GET_CUSTOMER_TICKET_FOR_SITE,
  //Site Visit
  GET_SITE_VISIT_COMPLETED,
  GET_SITE_VISIT_COMPLETED_FILTER_PROJECT,
  GET_ITEM_FOR_TRAVEL_BILL,
  GET_TRAVEL_BILL_DETAILS
} from "./types";

const initialState = {
  getCrmEnquiry: [],
  getCrmEnquirySource: [],
  getCustomerBudget: [],
  getCustomerConstructionPlanning: [],
  getCustomerPurchaseReason: [],
  getCrmSiteSold: [],
  getCrmCustomerEnquiry: [],
  getCrmEnquiryProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryProfileExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteVisitFeedbackQuestion: [],
  getSiteVisitFeedback: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteVisitFeedbackExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteVisitFeedbackDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingEnquiryProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingAttendee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingChannelPartnerInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingClientInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmPreferredLocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmPreferredLocationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingStmInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSourceGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSourceGroupExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCrmSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCrmEnquiryCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryCallStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmDimensionMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmReleaseStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSitePremiumType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteInvestor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBlockReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEnquiryFollowStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingChannelPartner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingClient: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingFilterHostedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFellowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFellowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmFollowUpFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //CRM Demsion
  getCrmDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryFollowUpReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteFace: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmCancellationReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //promotional activity
  getPromotionalActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalActivityFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  checkExistingEnquiry: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActivityForPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadFilterActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceForPromotionLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceForPromotionLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserForPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //site visit
  getLeadForSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadDetailForSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSitevisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEoiPrice: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getEoiPriceFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEoiPriceFilterDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterestDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterestFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEoiPriceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyForCrmProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEOIPaymentDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteFacing: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Customer Ticket //
  getCustomerTicket: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketForSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketForAssignedUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //CustomerTicketCategory
  getCustomerTicketCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketCategoryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Site Visit Completed
  getSitevisitCompleted: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSitevisitCompletedFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForTravelBill: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTravelBillDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const CRM_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CRM_ENQUIRY:
      return Object.assign({}, state, { getCrmEnquiry: payload });
    case GET_CRM_ENQUIRY_SOURCE:
      return Object.assign({}, state, { getCrmEnquirySource: payload });
    case GET_CUSTOMER_BUDGET:
      return Object.assign({}, state, { getCustomerBudget: payload });
    case GET_CRM_DIMENSION:
      return Object.assign({}, state, { getCrmDimension: payload });
    case GET_CUSTOMER_CONSTRUCTIONS_PLANNING:
      return Object.assign({}, state, {
        getCustomerConstructionPlanning: payload
      });
    case GET_CUSTOMER_PURCHASE_REASON:
      return Object.assign({}, state, { getCustomerPurchaseReason: payload });
    case GET_CRM_SITE_SOLD:
      return Object.assign({}, state, { getCrmSiteSold: payload });
    case GET_CRM_CUSTOMER_ENQUIRY:
      return Object.assign({}, state, { getCrmCustomerEnquiry: payload });
    case GET_CRM_ENQUIRY_PROFILE:
      return Object.assign({}, state, { getCrmEnquiryProfile: payload });
    case GET_CRM_ENQUIRY_PROFILE_EXPORT:
      return Object.assign({}, state, {
        getCrmEnquiryProfileExport: payload
      });
    case GET_SITE_VISIT_FEEDBACK_QUESTION:
      return Object.assign({}, state, {
        getSiteVisitFeedbackQuestion: payload
      });
    case GET_SITE_VISIT_FEEDBACK:
      return Object.assign({}, state, { getSiteVisitFeedback: payload });
    case GET_SITE_VISIT_FEEDBACK_EXPORT:
      return Object.assign({}, state, {
        getSiteVisitFeedbackExport: payload
      });
    case GET_SITE_VISIT_FEEDBACK_DETAIL:
      return Object.assign({}, state, {
        getSiteVisitFeedbackDetail: payload
      });
    case GET_CRM_BOOKING_ENQUIRY_PROFILE:
      return Object.assign({}, state, {
        getCrmBookingEnquiryProfile: payload
      });
    case GET_CRM_MEETING:
      return Object.assign({}, state, { getCrmMeeting: payload });

    // case GET_CRM_PROJECTS:
    //     return Object.assign({}, state, { getCrmProjects: payload });

    case GET_CRM_MEETING_CATEGORY:
      return Object.assign({}, state, { getCrmMeetingCategory: payload });

    case GET_CRM_MEETING_ATTENDEE:
      return Object.assign({}, state, { getCrmMeetingAttendee: payload });
    case GET_CRM_MEETING_DETAIL:
      return Object.assign({}, state, { getCrmMeetingDetail: payload });
    case GET_CRM_MEETING_EXPORT:
      return Object.assign({}, state, { getCrmMeetingExport: payload });
    case GET_CRM_MEETING_SOURCE:
      return Object.assign({}, state, { getCrmMeetingSource: payload });
    case GET_CRM_MEETING_CHANNEL_PARTNER_INFO:
      return Object.assign({}, state, {
        getCrmMeetingChannelPartnerInfo: payload
      });
    case GET_CRM_MEETING_CHANNEL_CLIENT_INFO:
      return Object.assign({}, state, { getCrmMeetingClientInfo: payload });
    case GET_CRM_MEETING_PREFERRED_LOCATION:
      return Object.assign({}, state, { getCrmPreferredLocation: payload });
    case GET_CRM_MEETING_PREFERRED_LOCATION_EXPORT:
      return Object.assign({}, state, {
        getCrmPreferredLocationExport: payload
      });
    case GET_CRM_MEETING_STM_INFO:
      return Object.assign({}, state, { getCrmMeetingStmInfo: payload });
    case GET_CRM_SOURCE_GROUP:
      return Object.assign({}, state, { getCrmSourceGroup: payload });

    case GET_CRM_SOURCE_GROUP_EXPORT:
      return Object.assign({}, state, { getCrmSourceGroupExport: payload });
    case GET_CRM_SOURCE_CATEGORY:
      return Object.assign({}, state, { getCrmSourceCategory: payload });
    case GET_CRM_SOURCE:
      return Object.assign({}, state, { getCrmSource: payload });
    case GET_CRM_ENQUIRY_STATUS:
      return Object.assign({}, state, { getCrmEnquiryStatus: payload });
    case GET_CRM_ENQUIRY_CATEGORY:
      return Object.assign({}, state, { getCrmEnquiryCategory: payload });
    case GET_CRM_ENQUIRY_CALL_STATUS:
      return Object.assign({}, state, { getCrmEnquiryCallStatus: payload });
    case GET_DIMENSION_MASTER:
      return Object.assign({}, state, { getCrmDimensionMaster: payload });

    case GET_RELEASE_STATUS:
      return Object.assign({}, state, { getCrmReleaseStatus: payload });
    case GET_CRM_SITE_PREMIUM_TYPE:
      return Object.assign({}, state, { getCrmSitePremiumType: payload });
    case GET_CRM_SITE_STATUS:
      return Object.assign({}, state, { getCrmSiteStatus: payload });
    case GET_SITE_INVESTOR:
      return Object.assign({}, state, { getCrmSiteInvestor: payload });
    case GET_BLOCK_REASON:
      return Object.assign({}, state, { getCrmBlockReason: payload });
    case GET_ENQUIRY_FOLLOW_STATUS:
      return Object.assign({}, state, { getEnquiryFollowStatus: payload });
    case GET_CRM_CHANNEL_PARTNER:
      return Object.assign({}, state, { getCrmMeetingChannelPartner: payload });
    case GET_CRM_CLIENT:
      return Object.assign({}, state, { getCrmMeetingClient: payload });
    case GET_CRM_STM:
      return Object.assign({}, state, { getCrmMeetingStm: payload });
    case GET_CRM_MEETING_FILTER_PROJECT:
      return Object.assign({}, state, { getCrmMeetingFilterProject: payload });
    case GET_CRM_MEETING_FILTER_HOSTED_BY:
      return Object.assign({}, state, { getCrmMeetingFilterHostedBy: payload });
    case GET_FELLOW_UP:
      return Object.assign({}, state, { getFellowUp: payload });
    case GET_FELLOW_UP_EXPORT:
      return Object.assign({}, state, { getFellowUpExport: payload });
    case GET_CRM_FOLLOW_UP_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, {
        getCrmFollowUpFilterAssignedTo: payload
      });
    case GET_CRM_ENQUIRY_FOLLOW_UP_REASON:
      return Object.assign({}, state, {
        getCrmEnquiryFollowUpReason: payload
      });
    case GET_CRM_SITE_FACE:
      return Object.assign({}, state, {
        getCrmSiteFace: payload
      });
    case GET_CRM_CANCELLATION_REASON:
      return Object.assign({}, state, {
        getCrmCancellationReason: payload
      });

    //promotional activity
    case GET_PROMOTIONAL_ACTIVITY:
      return Object.assign({}, state, {
        getPromotionalActivity: payload
      });
    case GET_PROMOTIONAL_ACTIVITY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPromotionalActivityFilterProject: payload
      });
    case CHECK_EXISTING_ENQUIRY:
      return Object.assign({}, state, {
        checkExistingEnquiry: payload
      });
    case GET_ACTIVITY_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getActivityForPromotionalLead: payload
      });
    case GET_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getPromotionalLead: payload
      });
    case GET_PROMOTIONAL_LEAD_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPromotionalLeadFilterProject: payload
      });
    case GET_PROMOTIONAL_LEAD_FILTER_SOURCE:
      return Object.assign({}, state, {
        getPromotionalLeadFilterSource: payload
      });
    case GET_PROMOTIONAL_LEAD_FILTER_ACTIVITY:
      return Object.assign({}, state, {
        getPromotionalLeadFilterActivity: payload
      });
    case GET_SOURCE_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getSourceForPromotionLead: payload
      });
    case GET_USER_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getUserForPromotionalLead: payload
      });

    //site visit
    case GET_LEAD_FOR_SITE_VISIT:
      return Object.assign({}, state, {
        getLeadForSiteVisit: payload
      });
    case GET_LEAD_DETAIL_FOR_SITE_VISIT:
      return Object.assign({}, state, {
        getLeadDetailForSiteVisit: payload
      });
    case GET_SITE_VISIT:
      return Object.assign({}, state, {
        getSitevisit: payload
      });
    case GET_EOI_PRICE:
      return Object.assign({}, state, {
        getEoiPrice: payload
      });

    case GET_EOI_PRICE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getEoiPriceFilterProject: payload
      });

    case GET_EXPRESSION_OF_INTEREST:
      return Object.assign({}, state, {
        getExpressionOfInterest: payload
      });

    case GET_EXPRESSION_OF_INTEREST_EXPORT:
      return Object.assign({}, state, {
        getExpressionOfInterestExport: payload
      });

    case GET_EOI_PRICE_FILTER_DIMENSION:
      return Object.assign({}, state, {
        getEoiPriceFilterDimension: payload
      });
    case GET_CUSTOMER_INFO:
      return Object.assign({}, state, {
        getCustomerInfo: payload
      });
    case GET_EXPRESSION_OF_INTEREST_DETAIL:
      return Object.assign({}, state, {
        getExpressionOfInterestDetail: payload
      });
    case GET_EXPRESSION_OF_INTEREST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getExpressionOfInterestFilterProject: payload
      });
    case GET_EOI_PRICE_DETAIL:
      return Object.assign({}, state, {
        getEoiPriceDetail: payload
      });
    case GET_COMPANY_FOR_CRM_PROJECT:
      return Object.assign({}, state, {
        getCompanyForCrmProject: payload
      });
    case GET_EOI_PAYMENT_DETAIL:
      return Object.assign({}, state, {
        getEOIPaymentDetail: payload
      });
    case GET_SITE_FACING:
      return Object.assign({}, state, {
        getSiteFacing: payload
      });
    // CustomerTicket
    case GET_CUSTOMER_TICKET:
      return Object.assign({}, state, {
        getCustomerTicket: payload
      });
    case GET_CUSTOMER_TICKET_EXPORT:
      return Object.assign({}, state, {
        getCustomerTicketExport: payload
      });
    case GET_CUSTOMER_TICKET_FOR_SITE:
      return Object.assign({}, state, {
        getCustomerTicketForSite: payload
      });
    case GET_USER_TICKET_FILTER:
      return Object.assign({}, state, {
        getCustomerTicketFilterAssignedTo: payload
      });
    case GET_CUSTOMER_TICKET_FOR_ASSINGNED_USER:
      return Object.assign({}, state, {
        getCustomerTicketForAssignedUser: payload
      });
    case GET_TICKET_FOLLOW_UP:
      return Object.assign({}, state, {
        getTicketFollowUp: payload
      });
    case GET_CUSTOMER_TICKET_DETAIL:
      return Object.assign({}, state, {
        getCustomerTicketDetail: payload
      });
    case GET_PROJECT_TICKET_FILTER:
      return Object.assign({}, state, {
        getCustomerTicketFilterProject: payload
      });
    case GET_CUSTOMER_TICKET_STATUS:
      return Object.assign({}, state, {
        getCustomerTicketStatus: payload
      });
    //CustomerTicketCategory
    case GET_CUSTOMER_TICKET_CATEGORY:
      return Object.assign({}, state, {
        getCustomerTicketCategory: payload
      });
    case GET_CUSTOMER_TICKET_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getCustomerTicketCategoryExport: payload
      });
    case GET_CUSTOMER_TICKET_FILTER_STATUS:
      return Object.assign({}, state, {
        getCustomerTicketFilterStatus: payload
      });
    //CustomerTicketCategory
    case GET_CUSTOMER_TICKET_CATEGORY:
      return Object.assign({}, state, {
        getCustomerTicketCategory: payload
      });
    case GET_CUSTOMER_TICKET_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getCustomerTicketCategoryExport: payload
      });
    case GET_CUSTOMER_TICKET_FILTER_STATUS:
      return Object.assign({}, state, {
        getCustomerTicketFilterStatus: payload
      });
    // Site Visit Completed
    case GET_SITE_VISIT_COMPLETED:
      return Object.assign({}, state, {
        getSitevisitCompleted: payload
      });
    case GET_SITE_VISIT_COMPLETED_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSitevisitCompletedFilterProject: payload
      });
    case GET_ITEM_FOR_TRAVEL_BILL:
      return Object.assign({}, state, {
        getItemForTravelBill: payload
      });
    case GET_TRAVEL_BILL_DETAILS:
      return Object.assign({}, state, {
        getTravelBillDetail: payload
      });
    default:
      return state;
  }
};
export default CRM_reducer;
